import { render, staticRenderFns } from "./ArchiveArrowDownOutline.vue?vue&type=template&id=085ace68"
import script from "./ArchiveArrowDownOutline.vue?vue&type=script&lang=js"
export * from "./ArchiveArrowDownOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports